import {Component, Inject, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppStorage} from '../../shared/services/appStorage.service';

import {Router, ActivatedRoute, Params} from '@angular/router';
import {LoginService} from '../../shared/services/login.service';
import {ModalErrorLoginComponent} from '../../shared/components/modal-error-login/modal-error-login.component';
import {MatDialog, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-cognito',
  templateUrl: './cognito.component.html',
  styleUrls: ['./cognito.component.css']
})
export class CognitoComponent implements OnInit {

  usuario: any;
  pass: any;
  check = false;
  dialogRef: MatDialogRef<ModalErrorLoginComponent>;
  token: any;
  myfragment: any;
  access_token: any;
  expires_in: any;

  constructor(
    public loginService: LoginService,
    public dialog: MatDialog,
    public httpClient: HttpClient,
    public appStorage: AppStorage,
    public activatedRoute: ActivatedRoute,
    public router: Router) {
  }

  ngOnInit() {
    this.activatedRoute.fragment.subscribe((fragments) => {

      if (fragments) {
        fragments = '&' + fragments;

        this.myfragment = fragments.split('=');

        console.log(this.myfragment[0]);

        if (this.myfragment[0] === '&access_token') {
          this.access_token  = fragments.split('&')[1].replace('access_token=', '');
          this.expires_in    = fragments.split('&')[4].replace('expires_in=', '');
        } else {
          this.access_token  = fragments.split('&')[2].replace('access_token=', '');
          this.expires_in    = fragments.split('&')[4].replace('expires_in=', '');
        }

        this.login(this.access_token, this.expires_in);
      }
    });
  }

  login(token, expires_in) {
    this.appStorage.loadingGeneral = true;
    this.loginService.loginCognito(token, expires_in).then((res: any) => {

        if (res.body.authorization) {
          this.appStorage.token = res.body.authorization;
          this.appStorage.cognitoCoordinador = true;
          this.getDatosSesion(this.check);
        } else {
          console.log('Error login');
        }

        this.appStorage.loadingGeneral = false;

      })
      .catch(error => {

        if (error.status === 401) {
          this.dialogRef = this.dialog.open(ModalErrorLoginComponent, {
            width: '450px'
          });
        }

        localStorage.removeItem('token');
        this.appStorage.conSesion = false;
        this.appStorage.loadingGeneral = false;
      });
  }

  getDatosSesion(check) {
    this.loginService.getDatosSesion().then((res: any) => {
        this.appStorage.datosSesion = {
          usuario: res.usuario,
          perfil: res.idperfil
        };
        this.appStorage.conSesion     = true;
        this.appStorage.loadingSesion = false;

        if (this.check) {
          localStorage.setItem('token', this.appStorage.token);
        } else {
          sessionStorage.setItem('token', this.appStorage.token);
          localStorage.removeItem('token');
        }

        if (this.router.url === '/') {
          this.appStorage.goHome();
        }
        this.router.navigate(['/admin']);
        if ((<any>window).PasswordCredential) {
          const c = new (<any>window).PasswordCredential({
            id: res.usuario,
            idName: 'username',
            password: 'pass',
            passwordName: this.appStorage.inputName,
            name: 'IFC'
          });
          return (<any>navigator).credentials.store(c);
        } else {
          console.log('no hay credential');
        }
      })
      .catch(error => {
        this.appStorage.token = undefined;
        this.appStorage.conSesion = false;
        this.appStorage.loadingSesion = false;
      });
  }
}
